/*
(c) Copyright European Space Agency, 2023

Project name: THEMIS: Tracking the Health of the Environment and Missions in Space

Description: Space Capacity Class component for Capacity Evaluation
Author: Deimos Space UK

Version: 1.0
*/

import React from "react";
import {  Card, CardBody , Row, Button} from "reactstrap";
import Chart from 'react-apexcharts';
import { ESA_COLORS } from "../../../core/models/colors";
export default function SpaceCapacityClass() {
    const apexDonutOpts = {
        chart: {
            height: 240,
            type: 'pie',
        },
        labels: ['Series 1', 'Series 2', 'Series 3', 'Series 4', 'Series 5'],
        colors: ESA_COLORS,
        legend: {
            show: true,
            position: 'bottom',
            horizontalAlign: 'center',
            verticalAlign: 'middle',
            floating: false,
            fontSize: '14px',
            offsetX: 0,
            offsetY: 10,
        },
        responsive: [
            {
                breakpoint: 600,
                options: {
                    chart: {
                        height: 240,
                    },
                    legend: {
                        show: false,
                    },
                },
            },
        ],
    };

    const apexDonutData = [44, 55, 41, 17, 15];
  return (
    <Card className="widget-flat h-100 mt-3">
      <CardBody>
      <Row >
        <h4 style={{color:'#003247'}} className="header-title float-left col " >SPACE CAPACITY BY CLASS</h4>
        <Button style={{background:'#003247'}}  className="float-right"><i className="uil  uil-down-arrow "></i></Button>
        </Row>
        <Chart
                    options={apexDonutOpts}
                    series={apexDonutData}
                    type="donut"
                    height={300}
                    className="apex-charts"
                />
      </CardBody>
    </Card>
  );
}
